import useScrollReveal from '../hooks/useScrollReveal';
import { FACILITY_IMAGES } from '../data';
import './About.css';

export default function About() {
  const ref = useScrollReveal();

  const timelineData = [
    [
      '2025',
      'Humble Beginnings',
      'Fitness King started with a clear mission—to create a premium training space focused on discipline, performance, and real transformation.',
    ],
    [
      '2013',
      'Growth & Expansion',
      'As the community grew, we expanded our training area, introduced group sessions, and brought in specialist coaches.',
    ],
    [
      '2016',
      'Facility Upgrade',
      'We upgraded our gym with better equipment, improved training zones, and a more complete fitness experience for every member.',
    ],
    [
      '2019',
      'Stronger Community',
      'Fitness King became more than a gym—it became a place where people trained harder, stayed accountable, and grew together.',
    ],
    [
      '2022',
      'Trusted by More Members',
      'With consistent results and strong member trust, our gym earned a reputation for quality coaching and a results-driven environment.',
    ],
    [
      'Today',
      'Still Building',
      'We continue to grow with the same mindset: better coaching, better energy, and better results for everyone who walks in.',
    ],
  ];

  const valuesData = [
    {
      icon: '🎯',
      title: 'Results Focused',
      text: 'Everything we do is built around helping members achieve visible, measurable progress.',
    },
    {
      icon: '🤝',
      title: 'Community First',
      text: 'We believe real growth happens in a positive environment filled with support and accountability.',
    },
    {
      icon: '🔬',
      title: 'Smart Training',
      text: 'Our approach combines practical coaching with proven fitness principles for better long-term results.',
    },
    {
      icon: '⭐',
      title: 'High Standards',
      text: 'From equipment quality to coaching quality, we aim to maintain a premium training experience.',
    },
    {
      icon: '🌱',
      title: 'Constant Improvement',
      text: 'We keep evolving our facility, methods, and training standards to serve members better.',
    },
    {
      icon: '♿',
      title: 'For Everyone',
      text: 'Whether you are a beginner or advanced athlete, we create a space where everybody can improve.',
    },
  ];

  const statsData = [
    ['10K+', 'Members Inspired'],
    ['50+', 'Training Programs'],
    ['25K', 'Sq. Ft. Vision'],
    ['4', 'Specialized Zones'],
    ['15+', 'Years of Passion'],
  ];

  return (
    <div ref={ref}>
      {/* HERO */}
      <div className="page-hero">
        <div className="about-hero-bg" />
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <div className="sec-eyebrow fade-up">Our Story</div>
          <h1 className="page-title-xl fade-up delay-1">
            WHO <span className="acc">WE ARE</span>
          </h1>
        </div>
      </div>

      {/* STORY */}
      <section className="section">
        <div className="section-inner">
          <div className="story-grid">
            <div className="fade-left">
              <div className="sec-eyebrow">The Origin</div>
              <h2 className="sec-title">
                BUILT ON <span className="acc">IRON WILL</span>
              </h2>
              <div className="divider" />

              <p className="sec-desc">
                Fitness King was built on one powerful belief—that fitness should
                transform not only the body, but also confidence, discipline, and
                lifestyle. What started as a passionate vision has grown into a
                place where people come to push limits and unlock their best selves.
              </p>

              <p className="sec-desc" style={{ marginTop: '1rem' }}>
                Today, Fitness King stands as a modern training destination in
                Jagamara, Bhubaneswar—designed for those who want serious workouts,
                expert guidance, and a motivating community. Our mission remains the
                same: help every member become stronger, healthier, and more
                confident.
              </p>
            </div>

            <div className="fade-right">
              <div className="timeline">
                {timelineData.map(([yr, tit, txt]) => (
                  <div className="tl-item" key={yr + tit}>
                    <div className="tl-year">{yr}</div>
                    <div className="tl-title">{tit}</div>
                    <div className="tl-text">{txt}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section
        className="section about-values-section"
      >
        <div className="section-inner">
          <div className="text-center fade-up about-values-head">
            <div className="sec-eyebrow center-eyebrow">What Drives Us</div>
            <h2 className="sec-title">
              OUR <span className="acc">CORE VALUES</span>
            </h2>
            <div className="divider center" />
          </div>

          <div className="values-grid">
            {valuesData.map((v, i) => (
              <div className={`value-card fade-up delay-${(i % 3) + 1}`} key={v.title}>
                <span className="value-icon">{v.icon}</span>
                <div className="value-title">{v.title}</div>
                <div className="value-text">{v.text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FACILITY */}
      <section className="section about-facility-section">
        <div className="section-inner">
          <div className="fade-up about-facility-head">
            <div className="sec-eyebrow">Inside Fitness King</div>
            <h2 className="sec-title">
              THE <span className="acc">FACILITY</span>
            </h2>
            <div className="divider" />
          </div>
        </div>

        <div className="facility-mosaic">
          {FACILITY_IMAGES.slice(0, 8).map((src, i) => (
            <div
              className={`fm-item fm-${i + 1} fade-up`}
              key={i}
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <img src={src} alt={`Fitness King facility ${i + 1}`} loading="lazy" />
            </div>
          ))}
        </div>
      </section>

      {/* NUMBERS */}
      <div className="numbers-band">
        <div className="section-inner">
          <div className="nb-grid-about">
            {statsData.map(([n, l], i) => (
              <div className={`nb-item fade-up delay-${i + 1}`} key={l}>
                <span className="nb-num">{n}</span>
                <div className="nb-label">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}